import * as React from 'react';
import { connect } from 'react-redux';
import { FormItem, Input } from 'elmo-elements';
import ErrorBox from 'element/ErrorBox';
import { StoreState } from 'state/types';
import {
  BOX_EDIT_TEMPLATE_CLOSE_SAVE_AS_TEMPLATE_MODAL,
  BOX_EDIT_TEMPLATE_CONFIRM_SAVE_AS_TEMPLATE_MODAL,
  BOX_EDIT_TEMPLATE_SAVE_AS_CLEAR_ERRORS,
} from 'state/Roster/EditTemplate/actions';
import { getSaveAsTemplateModal } from 'state/Roster/EditTemplate/selectors';
import { ConfirmModalProps } from 'state/Roster/EditTemplate/types';
import { useEffect, useState } from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'extended-oxygen-elements';
import { PageDialog, PageDialogCancel, PageDialogSubmit } from 'element';

type OwnProps = {};

type DispatchProps = {
  closeModal: () => void;
  confirmSaveAs: (name: string) => void;
  clearErrors: () => void;
};

type StateProps = {
  modal: ConfirmModalProps;
};

type Props = OwnProps & DispatchProps & StateProps;

export function SaveAsTemplateModal(props: Props) {
  const [name, setName] = useState('');

  useEffect(() => {
    setName('');
  }, [props.modal.isOpened]);

  const {
    modal: { isOpened, isUpdating, errors },
    closeModal,
    confirmSaveAs,
    clearErrors,
  } = props;

  return (
    <PageDialog
      maxWidth={'xs'}
      open={isOpened}
      id="save-as-modal"
      onClose={closeModal}
    >
      <DialogTitle>Save as</DialogTitle>
      <DialogContent>
        {errors.length > 0 && (
          <ErrorBox errors={errors} clearErrors={clearErrors} />
        )}
        <FormItem label={'Template name'}>
          <Input
            id="template-name"
            name="name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </FormItem>
      </DialogContent>
      <DialogActions>
        <PageDialogCancel onClick={closeModal}>Cancel</PageDialogCancel>
        <PageDialogSubmit
          id="save-modal"
          onClick={() => {
            confirmSaveAs(name);
          }}
          loading={isUpdating}
          disabled={!name.length}
        >
          Save
        </PageDialogSubmit>
      </DialogActions>
    </PageDialog>
  );
}

const mapToStateProps = (state: StoreState): StateProps => ({
  modal: getSaveAsTemplateModal(state),
});

const mapToDispatchProps: DispatchProps = {
  closeModal: BOX_EDIT_TEMPLATE_CLOSE_SAVE_AS_TEMPLATE_MODAL,
  confirmSaveAs: BOX_EDIT_TEMPLATE_CONFIRM_SAVE_AS_TEMPLATE_MODAL,
  clearErrors: BOX_EDIT_TEMPLATE_SAVE_AS_CLEAR_ERRORS,
};

export default connect(
  mapToStateProps,
  mapToDispatchProps
)(SaveAsTemplateModal);
